import React, { useEffect, useRef, useState } from 'react';

function useCountUp(target: number, suffix: string, duration: number, trigger: boolean) {
  const [val, setVal] = useState('0' + suffix);
  useEffect(() => {
    if (!trigger) return;
    const start = performance.now();
    const isFloat = target % 1 !== 0;
    const tick = (now: number) => {
      const p = Math.min((now - start) / duration, 1);
      const ease = 1 - Math.pow(1 - p, 3);
      setVal((isFloat ? (ease * target).toFixed(1) : Math.floor(ease * target)) + suffix);
      if (p < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }, [trigger, target, suffix, duration]);
  return val;
}

function StatItem({ target, suffix, label, dur }: { target: number; suffix: string; label: string; dur: number }) {
  const ref = useRef<HTMLDivElement>(null);
  const [triggered, setTriggered] = useState(false);
  const val = useCountUp(target, suffix, dur, triggered);
  useEffect(() => {
    const el = ref.current; if (!el) return;
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) { setTriggered(true); obs.unobserve(el); } }, { threshold: 0.5 });
    obs.observe(el); return () => obs.disconnect();
  }, []);
  return (
    <div ref={ref} className="flex-1 min-w-[160px] max-w-[240px] text-center px-6 py-5 lg:border-r lg:border-white/10">
      <span className="text-[40px] font-bold tracking-[-1.5px] block mb-1 text-pink-300 hover:scale-105 transition-transform duration-300">{val}</span>
      <span className="text-[13px] text-white/50 uppercase tracking-wide">{label}</span>
    </div>
  );
}

export default function Stats() {
  return (
    <div className="bg-black text-white flex justify-center flex-wrap px-[5%] py-10">
      <StatItem target={50}  suffix="K+" label="Active users"      dur={1800} />
      <StatItem target={8}   suffix="K+" label="Connections made"  dur={1400} />
      <StatItem target={4.8} suffix="★"  label="App rating"        dur={1200} />
      <div className="flex-1 min-w-[160px] max-w-[240px] text-center px-6 py-5">
        <span className="text-[40px] font-bold tracking-[-1.5px] block mb-1 text-pink-300">All</span>
        <span className="text-[13px] text-white/50 uppercase tracking-wide">Cities in Malawi</span>
      </div>
    </div>
  );
}
